import { h } from "preact";
import * as BaseComp from "components/shared/footer/footer.js";
import { accessNested, joinClasses } from 'utils/utils';
import Button from 'components/core/button/button';
import s from 'components/shared/footer/footer.sss';

const nonRegions = [
	'au', 'br', 'ca', 'ca_fr',
	'cl', 'co', 'cr', 'gt',
	'hn', 'lam','mx', 'ni',
	'nz', 'pa', 'pe', 'pr', 'us'
];

export default class Footer extends BaseComp.default {

	componentDidMount() {
		let cookieScriptUrl = accessNested(this.props, 'appData.doc.cookieScript');
		if (cookieScriptUrl && typeof window !== 'undefined' && !this.jsLoaded) {
			this.jsLoaded = true;
			// legalinclude-legal
			let script = document.createElement('script');
			script.src = cookieScriptUrl + '?legal';
			document.head.insertBefore(script, document.head.firstChild);

			window.onload = () => {
				const cookieBanner = document.getElementById('legalinclude-cookie_banner');
				if (cookieBanner) {
					const acceptCookiesButton = document.getElementById('legalinclude-cookie_accept');
					acceptCookiesButton.tabIndex = 2;
					const cookiePolicy = cookieBanner.querySelector('a');
					cookiePolicy.tabIndex = 1;
				}
			};
		}
	}

	shouldComponentUpdate() {
		return false;
	}

	getLinks() {
		const { appData } = this.props;

		const regionSlug = accessNested(appData, 'meta.region.slug');
		const canUseTealium = nonRegions.indexOf(regionSlug) === -1;
		const useTealiumCookieConsent = accessNested(appData, 'options.enableTealiumCookieConsent');
		const useEnsightenCookieConsent = accessNested(appData, 'options.enableEnsighten');

		if (canUseTealium && (useTealiumCookieConsent || useEnsightenCookieConsent)) {
			const footerDataLinks = this.props.footerData ? 'footerData.links' : 'appData.footer.links';
			const linkList = this.getLinkList(accessNested(this.props, footerDataLinks), s.listItem, s.listLink, s.listNoLink);
			linkList.unshift(
				<li class={s.listItem}>
					<Button
						buttonClass={joinClasses(s.listLink, s.buttonClass, s.cookieConsent)}
					>
						<span onClick={useEnsightenCookieConsent ? this.ensightenAction : this.tealiumAction}>
							{accessNested(appData, 'copy.$COOKIE_CONSENT') || 'Cookie Settings'}
						</span>
					</Button>
				</li>
			);
			return linkList;
		}
		return super.getLinks();
	}

	tealiumAction() {
		if (window.DisneyGDPR && window.DisneyGDPR.Core && typeof window.DisneyGDPR.Core.openPreferencesDialog === 'function') {
			window.DisneyGDPR.Core.openPreferencesDialog();
		}
	}

	ensightenAction(e) {
		if (typeof window.__dataLayer?.OneTrustDialog === 'function') {
			window.__dataLayer?.OneTrustDialog(e);
		}
	}

	getExtraContent() {
		if (!accessNested(this.props, 'appData.doc.cookieScript')) {
			return;
		}
		return <div id="legal" />;
	}

	render(props) {
		// If the app is iframed there should be no footer
		if (typeof window !== 'undefined' && window.top !== window.self) {
			return;
		}
		return super.render(props);
	}
}
